export default function PageTitle(props){
    return(
      <section className="page-title-section bg-footer">
        <div className="container h2 text-primary font-secondary">
            {props.children}
        </div>
      </section>
    );
}
